(function ($) {
    /**
     *
     * @returns {*}
     */
    $.fn.productionAccordion = function (header, container, callbackOpen = null, callbackClose = null) {
        let accordion = {};
        accordion.header = header;
        accordion.container = container;
        accordion.callbackOpen = callbackOpen;
        accordion.callbackClose = callbackClose;

        /**
         *
         */
        accordion.open = () => {
            accordion.container.removeClass('this-closed');
            accordion.container.slideDown();
            accordion.header.removeClass('folder-closed');
            accordion.header.addClass('folder-open');
            if (accordion.callbackOpen) {
                accordion.callbackOpen();
            }
        }

        /**
         *
         */
        accordion.close = () => {
            accordion.container.addClass('this-closed');
            accordion.container.slideUp();
            accordion.header.removeClass('folder-open');
            accordion.header.addClass('folder-closed');
            if (accordion.callbackClose) {
                accordion.callbackClose();
            }
        }

        /**
         *
         */
        accordion.toggle = () => {
            if (accordion.container.hasClass('this-closed')) {
                accordion.open();
            } else {
                accordion.close();
            }
        }

        /**
         *
         */
        accordion.init = () => {
            accordion.initButtons();
        }

        /**
         *
         */
        accordion.initButtons = () => {
            accordion.header.off('click keydown').on('click keydown', () => {
                accordion.toggle();
            });
        }

        accordion.init();

        return accordion;
    }

}(jQuery));
